import script from "./SceneList.vue?vue&type=script&setup=true&lang=js"
export * from "./SceneList.vue?vue&type=script&setup=true&lang=js"

import "./SceneList.vue?vue&type=style&index=0&id=e3a56534&lang=scss&scoped=true"

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3a56534"]])

export default __exports__